export default {
    'halls.loading': 'Carregando',
    'halls.primary.title': 'Prática',
    'halls.middle.title': 'Especialista',
    'halls.high.title': 'Elite',
    'halls.top.title': 'Mestre',
    'halls.level.describe': 'Condição do salão',
    'halls.coin.not': 'Moedas insuficientes',
    'halls.setting.title': 'Configuração',
};